import { IntlShape } from 'react-intl';
import { getRoomsBasePath } from '../service/constants';

export type NavItem = {
  key: 'home' | 'groups' | 'family-tree' | 'graves' | 'store';
  label: string;
  href: string;
  roles?: Array<'guest' | 'member' | 'moderator' | 'admin' | 'portal_admin'>;
  feature?: 'store' | 'familyTree';
  pinned?: boolean;
  priority?: number;
};

export type Features = { store?: boolean; familyTree?: boolean };

export function getPrimaryNav(intl: IntlShape, isAuth: boolean, features: Features): NavItem[] {
  const items: NavItem[] = [
    {
      key: 'home',
      label: intl.formatMessage({ id: 'nav.sparks', defaultMessage: 'Sparks' }),
      href: '/sparks',
      pinned: true,
      priority: 0,
      roles: ['guest', 'member', 'moderator', 'admin', 'portal_admin'],
    },
    {
      key: 'groups',
      label: intl.formatMessage({ id: 'nav.groups', defaultMessage: 'Rooms' }),
      href: getRoomsBasePath(),
      pinned: true,
      priority: 1,
      roles: ['guest', 'member', 'moderator', 'admin', 'portal_admin'],
    },
    {
      key: 'graves',
      label: intl.formatMessage({ id: 'nav.graves', defaultMessage: 'Graves' }),
      href: '/graves',
      priority: 2,
      roles: ['guest', 'member', 'moderator', 'admin', 'portal_admin'],
    },
    {
      key: 'family-tree',
      label: intl.formatMessage({ id: 'nav.my_family', defaultMessage: 'My family' }),
      href: '/family-tree',
      priority: 3,
      roles: ['guest', 'member', 'moderator', 'admin', 'portal_admin'],
      feature: 'familyTree',
    },
  ];

  const allowed = items.filter(
    (i) => !i.roles || (isAuth ? i.roles.some((r) => r !== 'guest') : i.roles.includes('guest')),
  );
  return allowed.filter((i) => (i.feature ? !!features[i.feature] : true));
}
